import React from 'react';

import { IExtendedMessage } from 'interfaces/message-interfaces';

export function LeaveChannelTag({ message }: { message: IExtendedMessage }) {
  return <div>Leave Channel Tag</div>;
}
